import { useDispatch } from "react-redux";
import { actions as transferActions } from "reducers/transfers";

const useInternFieldChange = () => {
    const dispatch = useDispatch();

    const handleOnChangeAmount = (amount, values) => {
        dispatch(
            transferActions.setInternalTransferData({
                ...values,
                amountField: {
                    ...amount.values.amountField,
                },
            }),
        );
    };
    const handleChangeEmail = (e, values) => {
        dispatch(
            transferActions.setInternalTransferData({
                ...values,
                email: e.target.value,
            }),
        );
    };
    const handleChangeMessage = (e, values) => {
        dispatch(
            transferActions.setInternalTransferData({
                ...values,
                messageText: e.target.value,
            }),
        );
    };

    return { handleOnChangeAmount, handleChangeEmail, handleChangeMessage };
};

export default useInternFieldChange;
